<div class="ant-card-meta-avatar" *ngIf="nzAvatar">
  <ng-template [ngTemplateOutlet]="nzAvatar"></ng-template>
</div>
<div class="ant-card-meta-detail" *ngIf="nzTitle || nzDescription">
  <div class="ant-card-meta-title" *ngIf="nzTitle">
    <ng-container *nzStringTemplateOutlet="nzTitle">{{ nzTitle }}</ng-container>
  </div>
  <div class="ant-card-meta-description" *ngIf="nzDescription">
    <ng-container *nzStringTemplateOutlet="nzDescription">{{ nzDescription }}</ng-container>
  </div>
</div>